export enum ExamRoutes {
	Home,
	MocksHome
}
